module.exports = __webpack_public_path__ + "static/media/pix_footer.37365521.svg";